import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { ASSETS_URL } from '../../lib/config';

const CustomerLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [customerData, setCustomerData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('customer_token');
    const data = localStorage.getItem('customer_data');

    if (!token || !data) {
      navigate('/customer-portal/login');
      return;
    }

    try {
      setCustomerData(JSON.parse(data));
    } catch (err) {
      console.error('Error parsing customer data:', err);
      navigate('/customer-portal/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('customer_token');
    localStorage.removeItem('customer_data');
    toast.success('Logged out successfully');
    navigate('/customer-portal/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f5f5' }}>
      {/* Sidebar */}
      <div
        className="red-bg"
        style={{
          width: sidebarOpen ? '250px' : '80px',
          transition: 'width 0.3s',
          color: 'white',
          position: 'fixed',
          height: '100vh',
          overflowY: 'auto',
          zIndex: 1000
        }}
      >
        {/* Header */}
        <div style={{ padding: '20px', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          {sidebarOpen && (
            <h5 className="mb-0 text-white fw-bold">Universal Client Hub</h5>
          )}
        </div>

        {/* Navigation */}
        <nav style={{ padding: '20px 0' }}>
          <NavLink
            to="/customer-portal/dashboard"
            className={({ isActive }) =>
              `d-flex align-items-center text-white text-decoration-none px-3 py-3 ${
                isActive ? 'bg-white bg-opacity-25' : ''
              }`
            }
            style={{ transition: 'background 0.2s' }}
            onMouseEnter={(e) => {
              if (!e.currentTarget.classList.contains('bg-white')) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.classList.contains('bg-white')) {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <i className="bi bi-house-door-fill" style={{ fontSize: '20px', width: '30px' }}></i>
            {sidebarOpen && <span className="ms-2">Home</span>}
          </NavLink>

          <NavLink
            to="/customer-portal/my-quotes"
            className={({ isActive }) =>
              `d-flex align-items-center text-white text-decoration-none px-3 py-3 ${
                isActive ? 'bg-white bg-opacity-25' : ''
              }`
            }
            style={{ transition: 'background 0.2s' }}
            onMouseEnter={(e) => {
              if (!e.currentTarget.classList.contains('bg-white')) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (!e.currentTarget.classList.contains('bg-white')) {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <i className="bi bi-file-earmark-text-fill" style={{ fontSize: '20px', width: '30px' }}></i>
            {sidebarOpen && <span className="ms-2">My Quotes</span>}
          </NavLink>
        </nav>

        {/* Footer */}
        {sidebarOpen && (
          <div
            style={{
              position: 'absolute',
              bottom: '20px',
              left: 0,
              right: 0,
              padding: '0 20px'
            }}
          >
            {customerData && (
              <div className="mb-3 pb-3" style={{ borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                <div className="text-white" style={{ fontSize: '14px' }}>
                  <div className="fw-bold">{customerData.forename} {customerData.surname}</div>
                  <div className="text-white-50" style={{ fontSize: '12px' }}>{customerData.email}</div>
                </div>
              </div>
            )}
            <button
              onClick={handleLogout}
              className="btn btn-light w-100 btn-sm"
              style={{ fontSize: '14px' }}
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Logout
            </button>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div
        style={{
          marginLeft: sidebarOpen ? '250px' : '80px',
          transition: 'margin-left 0.3s',
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Top Bar */}
        <div
          style={{
            background: 'white',
            padding: '15px 30px',
            borderBottom: '1px solid #e0e0e0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="btn btn-light"
            style={{ border: 'none' }}
          >
            <i className="bi bi-list" style={{ fontSize: '24px' }}></i>
          </button>

          <img
            src={`${ASSETS_URL}/image.png`}
            alt="Logo"
            style={{
              height: '150px',
              objectFit: 'contain'
            }}
          />

          <div></div>
        </div>

        {/* Content Area */}
        <div style={{ flex: 1, padding: '30px', overflowY: 'auto' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CustomerLayout;
